import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Collapse } from "antd";
import styled from "styled-components";
import LoadingContent from "../../component/loading/LoadingContent";
import Map from "../../component/map/Index";
import StationProfile from "../../component/card/StationProfile";
import LineChart from "./LineChart";

import actions from "../../redux/actions";
import service from "../../service/Station";

const Section = styled.section`
  img {
    max-width: 1280px;
    max-height: 1024px;
  }

  .row {
    display: flex;
    justify-content: center;
  }
  .map {
    width: 100%;
    height: 400px;
  }

  .card-station-profile {
    width: 60%;
  }

  .form-line-chart-option {
    height: auto;
  }
`;

export default function Station(props) {
  const [data, setData] = useState([]);
  const [content, setContent] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.master.setPath("/stations"));
    const init = async () => {
      let detailData = await service.getDetail(props.stationId);
      if (detailData) {
        setData(detailData);
        setContent(true);
      } else {
        window.location.href = "/stations";
      }
    };

    init();
  }, [dispatch, props.stationId]);

  return (
    <Section
      className={"section-map" + (props.className ? props.className : "")}
    >
      <div className="container">
        {!content ? (
          <LoadingContent />
        ) : (
          <>
            <Collapse defaultActiveKey={["กราฟแสดงระดับน้ำ"]}>
              <Collapse.Panel header="กราฟแสดงระดับน้ำ" key="กราฟแสดงระดับน้ำ">
                <div className="sensor-container">
                  <div className="row">
                    {data.sensors.map((sensor) => (
                      <LineChart
                        key={sensor.id}
                        stationId={props.stationId}
                        sensorId={sensor.id}
                        sensorDispName={sensor.disp_name}
                      />
                    ))}
                  </div>
                </div>
              </Collapse.Panel>
            </Collapse>
            <Collapse defaultActiveKey={["จุดติดตั้งสถานีวัดระดับน้ำ"]}>
              <Collapse.Panel
                header="จุดติดตั้งสถานีวัดระดับน้ำ"
                key="จุดติดตั้งสถานีวัดระดับน้ำ"
              >
                <div className="map">
                  <Map
                    center={[data.gps_lat, data.gps_long]}
                    zoom={10}
                    data={[{ ...data }]}
                    noDesc
                  />
                </div>
              </Collapse.Panel>
            </Collapse>
            <Collapse defaultActiveKey={["รายละเอียดสถานีวัดระดับน้ำ"]}>
              <Collapse.Panel
                header="รายละเอียดสถานีวัดระดับน้ำ"
                key="รายละเอียดสถานีวัดระดับน้ำ"
              >
                <div className="row">
                  <StationProfile {...data} />
                </div>
              </Collapse.Panel>
            </Collapse>
            <Collapse defaultActiveKey={["ภาพสถานี"]}>
              <Collapse.Panel header="ภาพสถานี" key="ภาพสถานี">
                <div className="row">
                  <img src="/image/dashboard.png" alt="a" />
                </div>
              </Collapse.Panel>
            </Collapse>
          </>
        )}
      </div>
    </Section>
  );
}
